/**
 * Account detail comparison palette: teal (yours) vs umber (theirs).
 * Chrome neutrals stay separate from party colors.
 */
export const partyTheme = {
  yours: {
    text: "#0c3d45",
    textLabel: "#156b6f",
    bg: "#e8f4f2",
    border: "#5a9d94",
    button: "#156b6f",
    buttonBorder: "#0f5458",
  },
  theirs: {
    text: "#45341f",
    textLabel: "#6b4e2d",
    bg: "#f4efe6",
    border: "#9a8364",
  },
  chrome: {
    heading: "#1e3331",
    titleRule: "#9dbfb9",
    sidebarRule: "#b8cec9",
    cardBorder: "#c5cdd9",
    neutralRule: "#e0ddd6",
    panelBorder: "#d4cfc4",
    claimsRowHover: "#ececec",
    claimsRow: "#f7f7f7",
    claimsSubhead: "#f3f4f4",
  },
};
